<template>
    <div class="container-fluid">
        <Breadcrumb title="Add Message" v-bind:button-show="false" v-show="!id"></Breadcrumb>
        <Breadcrumb title="Edit Message" v-bind:button-show="false" v-show="id"></Breadcrumb>

        <div class="row position-relative">
            <div class="col-12 row-preloader" v-if="id">
                <Preloader v-bind:class="{preloader: loading}" v-show="loading"></Preloader>
            </div>
            <div class="col-12" v-show="!loading">
                <div class="card">
                    <div class="card-body">
                        <MessageForm :id="id" @hidePreloader="hidePreloader"></MessageForm>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Preloader from '../components/Preloader';
    import MessageForm from './forms/MessageForm';
    import Breadcrumb from '../components/Breadcrumb';

    export default {
        name: 'Message',
        props: ['id'],
        components: {
            Preloader, MessageForm, Breadcrumb
        },
        data() {
            return {
                loading: true
            }
        },
        mounted() {
            if (!this.id) {
                this.loading = false;
            }
        },
        methods: {
            hidePreloader(value) {
                this.loading = !value;
            }
        }
    }
</script>

<style scoped>

</style>
